import * as HLF from "html-living-framework";
import * as PIXI from "pixi.js";
import Settings from "Data/Settings";
import * as Topics from "Data/Topics";

export class FlyingGameObstacle extends PIXI.Container {
    public dodged?: boolean = undefined;
    private readonly _animatedSprite?: HLF.AnimatedSprite;
    private readonly _sprite?: PIXI.Sprite;

    public constructor(
        pTexture: string | {texture: string, frames: number},
        public speed: number,
        public readonly lane: number,
        public readonly isGrounded: boolean,
        public readonly name: string,
        public readonly nameVO: string,
        public readonly nameVOArticle: string,
        public readonly factVO: string,
    ) {
        super();

        if (typeof pTexture === "string") {
            this._sprite = this.addChild(HLF.PixiUtils.makeSprite(pTexture));
            this._sprite.anchor.set(0.5, isGrounded ? 1 : 0.5);
        }
        else {
            this._animatedSprite = this.addChild(new HLF.AnimatedSprite());
            this._animatedSprite.addAnimation("flying", new HLF.SpriteAnimation(
                pTexture.texture.replace(/\d+$/, ''), undefined as any as string, pTexture.frames, 2, 12, true, 1)
            );
            this._animatedSprite.anchor.set(0.5, isGrounded ? 1 : 0.5);
            this._animatedSprite.play("flying");
        }
    }

    public update(pDeltaTime: number) {
        if (Settings.moreAnimation) {
            this._animatedSprite?.update(pDeltaTime);
        }
        else {
            this._animatedSprite?.update(0);
        }
    }
}